var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorLiveDataOld1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.7,1.02c-1.34,0-2.42,1.09-2.42,2.42v11.95c0,1.34,1.09,2.42,2.42,2.42h11.95c1.34,0,2.42-1.09,2.42-2.42,0-7.93-6.45-14.38-14.38-14.38Zm12.51,14.38c0,.31-.25.56-.56.56h-11.95c-.31,0-.56-.25-.56-.56V3.45c0-.31.25-.56.56-.56,6.9,0,12.51,5.61,12.51,12.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.29,18.64c-.41,0-.77.27-.9.68-1.55,4.98-6.45,8.24-11.65,7.73-5.17-.5-9.43-4.78-9.91-9.96-.49-5.29,2.85-10.19,7.94-11.66.42-.12.7-.48.7-.9,0-.3-.14-.57-.37-.75s-.55-.23-.82-.15C4,5.45.06,11.69,1.09,18.17c.86,5.37,5.21,9.74,10.57,10.62.74.12,1.48.18,2.2.18,5.62,0,10.62-3.58,12.33-9.12.09-.29.04-.59-.14-.84s-.46-.38-.76-.38Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorLiveDataOld1);
export default __webpack_public_path__ + "static/media/monitor-live-data-old-1.3bd2d148f94a755ed125c2fef4824e8f.svg";
export { ForwardRef as ReactComponent };